import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SquareIcon from '@material-ui/icons/CropSquare';
import CheckBoxIcon from '@material-ui/icons/CheckBoxOutlined';

const useStyles = makeStyles(() => ({
  root: {
    padding: '0px'
  },
  checked: {
    color: props => `${props.value} !important`
  }
}));

const RectangularRadioButton = ({ title, value, ...rest }) => {
  const classes = useStyles({ value });

  return (
    <Box
      component={FormControlLabel}
      label={title}
      value={value}
      bgcolor="#FFF"
      control={
        <Radio
          classes={{ root: classes.root, checked: classes.checked }}
          icon={<SquareIcon />}
          checkedIcon={<CheckBoxIcon />}
        />
      }
      className={classes.checkboxStyle}
      {...rest}
    />
  );
};

RectangularRadioButton.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default RectangularRadioButton;
